import * as Sentry from "@sentry/react";

import { createLocalAxios } from "../../lib/api.js";
import apiMessages from "../../lib/apiMessages.js";
import { uuid } from "../../utils/utils.js";

import {
  loadingEstablishmentData,
  loadingEstablishmentDataDone,
  setEstablishmentData,
} from "./slice.js";

export const fetchEstablishments =
  ({ page = 1, pageSize = 10, searchTitle = undefined }) =>
  async (dispatch, getState) => {
    dispatch(loadingEstablishmentData());

    const localAxios = createLocalAxios(getState);
    let url = `establishment/establishments?page=${page}&page_size=${pageSize}`;
    if (searchTitle && searchTitle !== "") {
      url = `establishment/establishments?page=1&page_size=${pageSize}&filter[EST_NAME]=${searchTitle}`;
    }

    let response;
    try {
      response = await localAxios.get(url);
    } catch (error) {
      console.error("Error while fetching notifications:", error);
      Sentry.captureException(error);
      throw error;
    } finally {
      await dispatch(loadingEstablishmentDataDone());
    }

    await dispatch(setEstablishmentData(response.data.establishments));

    return response.data.pages;
  };

export const saveEstablishment =
  (values, establishmentId, principalId) => async (dispatch, getState) => {
    const localAxios = createLocalAxios(getState);
    const body = establishmentId
      ? values
      : { ...values, id: uuid(), principalType: "Establishment" };

    const url = establishmentId
      ? `establishment/establishment/${principalId}`
      : "establishment/establishment";

    let response;
    try {
      if (establishmentId) {
        response = await localAxios.patch(url, body);
      } else {
        response = await localAxios.post(url, body);
      }
    } catch (error) {
      console.error("Error while saving the establishment:", error);
      Sentry.captureException(
        new Error(
          `Something went wrong: saveEstablishment post/patch-> ${error}`,
        ),
      );
      throw error;
    }

    if (response.data.message !== apiMessages.MSG_SUCCESS) {
      throw new Error(response.data.message);
    }

    return response;
  };

export const fetchEstablishmentById = (id) => async (dispatch, getState) => {
  const localAxios = createLocalAxios(getState);
  const url = `establishment/establishment/${id}`;

  let response;
  try {
    response = await localAxios.get(url);
  } catch (error) {
    console.error("Error while fetching the establishment by id:", error);
    new Error(`Something went wrong: fetchEstablishmentById get -> ${error}`);
  }

  dispatch(setEstablishmentData([response.data]));
  return response.data;
};
